import { Box, IconButton, InputAdornment, Modal } from '@mui/material';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useState } from 'react';
import { useDropzone } from 'react-dropzone';

import BaseInputValidation from '@/components/ui/Input/BaseInputValidation';
import ButtonCloseModal from '@/components/ui/Button/ButtonCloseModal';
import BaseSelect from '@/components/ui/Select/BaseSelect';

import userIcon from '@/assets/icons/user-xl.png';
import ModalStyle from '@/constants/ModalStyle';

const schema = yup.object().shape({
	email: yup.string().required().email(),
	username: yup.string().required(),
	password: yup.string().required(),
	phonenumber: yup.string().required(),
	privilegelevelid: yup.string().required(),
});

export const InputPassword = ({ name, label, control, errors }) => {
	const [showPassword, setShowPassword] = useState(false);

	const handleClickShowPassword = () => {
		setShowPassword(!showPassword);
	};
	return (
		<BaseInputValidation
			control={control}
			name={name}
			label={label}
			errors={errors}
			config={{ type: showPassword ? 'text' : 'password' }}
			InputProps={{
				endAdornment: (
					<InputAdornment position='end'>
						<IconButton aria-label='toggle password visibility' onClick={handleClickShowPassword} edge='end'>
							{showPassword ? <VisibilityOff /> : <Visibility />}
						</IconButton>
					</InputAdornment>
				),
			}}
		/>
	);
};

export default function CreateUser(props) {
	const { open, onClose, onSave } = props;

	const [file, setFile] = useState(null);

	const {
		handleSubmit,
		control,
		reset,
		formState: { errors },
	} = useForm({
		resolver: yupResolver(schema),
		defaultValues: {
			username: '',
			surename: '',
			email: '',
			status: 1,
			privilegelevelid: '',
			password: '',
		},
	});

	const { getRootProps, getInputProps } = useDropzone({
		accept: {
			'image/*': '*',
		},
		multiple: false,
		onDrop: (file) => {
			setFile(
				Object.assign(file[0], {
					preview: URL.createObjectURL(file[0]),
				})
			);
		},
	});

	const handleClose = () => {
		reset();
		onClose();
	};

	const onSubmit = (dataForm) => {
		dataForm.surename = ""
		onSave(dataForm)
		handleClose();
	};

	return (
		<Modal open={open} onClose={handleClose} aria-labelledby='modal-notes' aria-describedby='modal-notes' className='w-full'>
			<Box sx={{ ...ModalStyle, top: '25%' }} className='flex flex-col gap-4 w-[90%] md:max-w-[990px]'>
				<span className='text-2xl modal-title'>Legg til bruker</span>
				<ButtonCloseModal onClose={handleClose} />
				<hr />

				<form onSubmit={handleSubmit(onSubmit)} className='flex w-full gap-4'>
					<div className='flex flex-col gap-2 min-w-48 min-h-48'>
						<div className='w-full h-full p-4 bg-white'>
							{file ? (
								<img src={file.preview} className='object-contain w-full h-full max-h-64' />
							) : (
								<div className='bg-[#D1D1D1] w-full h-full rounded-full'>
									<img src={userIcon} className='object-contain w-full' />
								</div>
							)}
						</div>

						<div {...getRootProps({ className: 'dropzone flex flex-col gap-2 cursor-pointer' })}>
							<div className='flex items-center justify-center w-full gap-4'>
								<label className='flex items-center'>
									<input {...getInputProps()} />
									<button className='h-10 px-4 text-white border border-gray-700 rounded-sm bg-bd-blue' type='button'>
										<span>Velg filer</span>
									</button>
									{file && <span className='ml-2'>{file.name}</span>}
								</label>
								{!file && <span>Ingen fil valgt</span>}
							</div>
						</div>
					</div>
					<div className='grid w-full grid-cols-10 gap-2'>
						<div className='flex flex-col col-span-5 gap-4'>
							<BaseInputValidation control={control} name='username' label='Brukernavn' errors={errors} required />
							<BaseInputValidation control={control} name='email' label='E-post' errors={errors} required config={{ type: 'email' }} />
							<BaseInputValidation control={control} name='departement' label='Avdeling' errors={errors} required />
							<BaseInputValidation control={control} name='password' label='Passord' errors={errors} required config={{ type: 'password' }} />
						</div>
						<div className='flex flex-col items-start col-span-5 gap-4'>
							<BaseInputValidation control={control} name='phonenumber' label='Telefonnummer' errors={errors} required />
							<BaseInputValidation control={control} name='location' label='Plassering' errors={errors} required />
							<BaseSelect
								control={control}
								name='privilegelevelid'
								label='Type'
								errors
								data={[
									{ id: 1, name: 'Developer', value: '1' },
									{ id: 2, name: 'Administrasjon', value: '2' },
									{ id: 2, name: 'Produktsjef', value: '3' },
									{ id: 2, name: 'Prosjektleder', value: '4' },
									{ id: 2, name: 'Ansatt', value: '5' },
									{ id: 2, name: 'Public', value: '6' },
									{ id: 2, name: 'Ekstern bruker', value: '7' },
									{ id: 2, name: 'Read only', value: '8' },
								]}
								config={{ styles: {}, classes: '', optionLabel: '--Select Version--' }}
								size='small'
							/>
						</div>
						<div className='flex items-end justify-end col-span-10'>
							<button className='btn h-fit'>Legg til</button>
						</div>
					</div>
				</form>
			</Box>
		</Modal>
	);
}
